<template lang="pug">
  .table-responsive
    table#tbConsumibles.table.is-striped.is-fullwidth
      thead
        tr
          th #
          th Categoría(s)
          th Descripción
          th Ubicación
          th Cantidad
          th Surtir
      tbody
        tr(v-for="(data, index) in consumibles" :key="index")
          td
            a.button.is-black.is-small.is-rounded {{ index + 1 }}
          td(v-if="data.subcategoria" @click="irConsumibleDetalle(data)")
            .control
              .tags.has-addons
                span.tag.is-black
                  i.fas.fa-tag
                  | &nbsp {{ data.categoria}}
                span.tag.is-warning {{ data.subcategoria}}
          td(v-else @click="irConsumibleDetalle(data)") 
            span.tag.is-black {{ data.categoria}}
          td 
            p.is-size-6
              .control
                .tags.has-addons
                  span.tag.is-info
                    | {{ data.marca }}
                  span.tag.is-light
                    | {{ data.modelo}}
          td
            span.tag.is-black {{ data.oficina}}
          td {{ data.cantidad }}
          td(v-html="isSurtible(data)")
</template>

<script>
  export default {
    name: "Tb_ConsumiblesSede",
    props: {
      consumibles: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        itemSel: {},
      }
    },
    methods: {
      irConsumibleDetalle(consumible) {
        console.log(consumible)
        this.$store.commit('selectConsumible', consumible)
        this.$router.push('/Inventario/Consumibles/Detalle')
      },
      isSurtible (consumible) {
        let text = ''
        if (parseInt(consumible.cantidad) <= parseInt(consumible.limite)) {
          text = `<span class="tag is-danger">Es necesario surtir.</span>`
        } else {
          text = `<span class="tag is-light">Aun no es necesario surtir.</span>`
        }
        return text
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/cedes/components/Tb_ConsumiblesSede.vue